export var idFromSlug = function idFromSlug(slug) {
  var id = slug.split("-").pop();
  var validId = /^[0-9]+$/.test(id);
  return validId ? id : "";
};